// The audio playback is not perfectly in sync with the events, so we need to seek a little bit back to get the correct time
export const AUDIO_SEEK_OFFSET = 2

// Scope the third-party picker's own variables to console tokens. Its stylesheet
// declares these on the root, so the overrides need to win over those defaults.
export const EMOJI_PICKER_THEME_CLASS_NAME = [
  '[&_*]:!font-inter',
  'dark:[color-scheme:dark]',
  '[&_input]:!text-s-400',
  '[&_.epr-emoji-category-label]:!text-xs-500',
  '![--epr-bg-color:hsl(var(--popover))]',
  '![--epr-text-color:hsl(var(--secondary))]',
  '![--epr-hover-bg-color:hsl(var(--muted))]',
  '![--epr-hover-bg-color-reduced-opacity:hsl(var(--muted)/0.7)]',
  '![--epr-focus-bg-color:hsl(var(--muted))]',
  '![--epr-search-input-bg-color:hsl(var(--bg2))]',
  '![--epr-search-border-color:hsl(var(--border))]',
  '![--epr-search-border-color-active:hsl(var(--ring))]',
  '![--epr-search-input-text-color:hsl(var(--foreground))]',
  '![--epr-search-input-placeholder-color:hsl(var(--tertiary))]',
  '![--epr-picker-border-color:hsl(var(--border))]',
  '![--epr-category-label-bg-color:hsl(var(--popover))]',
  '![--epr-category-label-text-color:hsl(var(--secondary))]',
  '![--epr-highlight-color:hsl(var(--brand-text))]',
  '![--epr-category-icon-active-color:hsl(var(--brand-text))]',
  '![--epr-picker-border-radius:var(--radius)]',
  '![--epr-search-input-border-radius:var(--radius)]',
].join(' ')
